<template>
    <div class="photoShow flex-center-xy" v-if="photoShows" @click="noShow" @touchmove.prevent @mousewheel.prevent>
      <img :src="url" alt="">
    </div>
</template>

<script>
export default {
  props: {
    url: {
      required: true
    },
    photoShows: {
      default: true
    }
  },
  data () {
    return {
      show: null
    }
  },
  computed: {
  },
  created () {

  },
  mounted () {

  },
  watch: {
  },
  methods: {
    noShow () {
      this.show = false
      this.$emit('showSrue', this.show)
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
  .flex-center-xy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .photoShow {
    width: 100%;
    height: 100%;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 1000;
    img {
      height: 500px;
    }
  }
</style>
